import React from "react";
import { Field } from "redux-form";
import { minLength, required, validateDate, alphaName, notEmpty } from "../../../utils/validate";
import { formatDate, toDate, toNumber, formatAmount } from "../../../utils/formatters";
import OptionList, { YesOrNoOptionList } from "../../Forms/OptionList/optionList";
import Input from "../../Forms/Input/input";
import Select from '../../Forms/Select/select';
import SsnInput from "../../Forms/SsnInput/ssnInput";
import PropTypes from "prop-types";

export const validateDateLength = minLength.bind(null, 8);
export const validateSsnLength = minLength.bind(null, 9);

const countriesOfCitizenship = [
  {
    "value": "AF",
    "text": "AFGHANISTAN"
  },
  {
    "value": "AL",
    "text": "ALBANIA"
  },
  {
    "value": "DZ",
    "text": "ALGERIA"
  },
  {
    "value": "AS",
    "text": "AMERICAN SAMOA"
  },
  {
    "value": "AD",
    "text": "ANDORRA"
  },
  {
    "value": "AO",
    "text": "ANGOLA"
  },
  {
    "value": "AI",
    "text": "ANGUILLA"
  },
  {
    "value": "AQ",
    "text": "ANTARCTICA"
  },
  {
    "value": "AG",
    "text": "ANTIGUA AND BARBUDA"
  },
  {
    "value": "AR",
    "text": "ARGENTINA"
  },
  {
    "value": "AM",
    "text": "ARMENIA"
  },
  {
    "value": "AW",
    "text": "ARUBA"
  },
  {
    "value": "AU",
    "text": "AUSTRALIA"
  },
  {
    "value": "AT",
    "text": "AUSTRIA"
  },
  {
    "value": "AZ",
    "text": "AZERBAIJAN"
  },
  {
    "value": "BS",
    "text": "BAHAMAS"
  },
  {
    "value": "BH",
    "text": "BAHRAIN"
  },
  {
    "value": "IB",
    "text": "BALEARIC ISLANDS"
  },
  {
    "value": "BD",
    "text": "BANGLADESH"
  },
  {
    "value": "BB",
    "text": "BARBADOS"
  },
  {
    "value": "BY",
    "text": "BELARUS"
  },
  {
    "value": "B2",
    "text": "BELAU"
  },
  {
    "value": "BE",
    "text": "BELGIUM"
  },
  {
    "value": "BZ",
    "text": "BELIZE"
  },
  {
    "value": "BJ",
    "text": "BENIN"
  },
  {
    "value": "BM",
    "text": "BERMUDA"
  },
  {
    "value": "BF",
    "text": "BFPO"
  },
  {
    "value": "BT",
    "text": "BHUTAN"
  },
  {
    "value": "BO",
    "text": "BOLIVIA"
  },
  {
    "value": "BA",
    "text": "BOSNIA-HERZEGOVINA"
  },
  {
    "value": "BW",
    "text": "BOTSWANA"
  },
  {
    "value": "BV",
    "text": "BOUVET IS."
  },
  {
    "value": "BR",
    "text": "BRAZIL"
  },
  {
    "value": "IO",
    "text": "BRIT. INDIAN OCEAN TERR."
  },
  {
    "value": "VG",
    "text": "BRITISH VIRGIN IS."
  },
  {
    "value": "BN",
    "text": "BRUNEI DARUSSALAM"
  },
  {
    "value": "BG",
    "text": "BULGARIA"
  },
  {
    "value": "HV",
    "text": "BURKINA FASO"
  },
  {
    "value": "BI",
    "text": "BURUNDI"
  },
  {
    "value": "KH",
    "text": "CAMBODIA"
  },
  {
    "value": "CM",
    "text": "CAMEROON"
  },
  {
    "value": "CA",
    "text": "CANADA"
  },
  {
    "value": "IC",
    "text": "CANARY ISLANDS"
  },
  {
    "value": "CV",
    "text": "CAPE VERDE IS."
  },
  {
    "value": "KY",
    "text": "CAYMAN IS."
  },
  {
    "value": "CF",
    "text": "CENTRAL AFRICAN REP."
  },
  {
    "value": "TD",
    "text": "CHAD"
  },
  {
    "value": "CL",
    "text": "CHILE"
  },
  {
    "value": "CN",
    "text": "CHINA"
  },
  {
    "value": "CX",
    "text": "CHRISTMAS IS."
  },
  {
    "value": "CC",
    "text": "COCOS (KEELING) IS."
  },
  {
    "value": "CO",
    "text": "COLOMBIA"
  },
  {
    "value": "KM",
    "text": "COMOROS"
  },
  {
    "value": "CG",
    "text": "CONGO"
  },
  {
    "value": "CK",
    "text": "COOK IS."
  },
  {
    "value": "CR",
    "text": "COSTA RICA"
  },
  {
    "value": "HR",
    "text": "CROATIA"
  },
  {
    "value": "CU",
    "text": "CUBA"
  },
  {
    "value": "CY",
    "text": "CYPRUS"
  },
  {
    "value": "CZ",
    "text": "CZECH REPUBLIC"
  },
  {
    "value": "CD",
    "text": "DEMOCRATIC REP. OF CONGO"
  },
  {
    "value": "DK",
    "text": "DENMARK"
  },
  {
    "value": "DJ",
    "text": "DJIBOUTI"
  },
  {
    "value": "DM",
    "text": "DOMINICA"
  },
  {
    "value": "DO",
    "text": "DOMINICAN REPUBLIC"
  },
  {
    "value": "EC",
    "text": "ECUADOR"
  },
  {
    "value": "EG",
    "text": "EGYPT"
  },
  {
    "value": "SV",
    "text": "EL SALVADOR"
  },
  {
    "value": "GQ",
    "text": "EQUITORIAL GUINEA"
  },
  {
    "value": "ER",
    "text": "ERITREA"
  },
  {
    "value": "EE",
    "text": "ESTONIA"
  },
  {
    "value": "ET",
    "text": "ETHIOPIA"
  },
  {
    "value": "FO",
    "text": "FAEROE IS."
  },
  {
    "value": "FK",
    "text": "FALKLAND IS."
  },
  {
    "value": "FJ",
    "text": "FIJI"
  },
  {
    "value": "FI",
    "text": "FINLAND"
  },
  {
    "value": "FR",
    "text": "FRANCE"
  },
  {
    "value": "FX",
    "text": "FRANCE, METROPOLITAN"
  },
  {
    "value": "GF",
    "text": "FRENCH GUIANA"
  },
  {
    "value": "PF",
    "text": "FRENCH POLYNESIA"
  },
  {
    "value": "FQ",
    "text": "FRENCH SOUTHERN TERRITORY"
  },
  {
    "value": "MQ",
    "text": "FRENCH WEST INDIES"
  },
  {
    "value": "GA",
    "text": "GABON"
  },
  {
    "value": "GM",
    "text": "GAMBIA"
  },
  {
    "value": "G3",
    "text": "GAZA & KHAN YUNIS"
  },
  {
    "value": "GE",
    "text": "GEORGIA"
  },
  {
    "value": "DE",
    "text": "GERMANY"
  },
  {
    "value": "GH",
    "text": "GHANA"
  },
  {
    "value": "GI",
    "text": "GIBRALTAR"
  },
  {
    "value": "GB",
    "text": "GREAT BRITAIN"
  },
  {
    "value": "GR",
    "text": "GREECE"
  },
  {
    "value": "GL",
    "text": "GREENLAND"
  },
  {
    "value": "GD",
    "text": "GRENADA"
  },
  {
    "value": "GP",
    "text": "GUADELOUPE"
  },
  {
    "value": "GU",
    "text": "GUAM"
  },
  {
    "value": "GT",
    "text": "GUATEMALA"
  },
  {
    "value": "GN",
    "text": "GUINEA"
  },
  {
    "value": "GW",
    "text": "GUINEA-BISSAU"
  },
  {
    "value": "GY",
    "text": "GUYANA"
  },
  {
    "value": "HT",
    "text": "HAITI"
  },
  {
    "value": "HM",
    "text": "HEARD AND MCDONALD IS."
  },
  {
    "value": "HN",
    "text": "HONDURAS"
  },
  {
    "value": "HK",
    "text": "HONG KONG"
  },
  {
    "value": "HU",
    "text": "HUNGARY"
  },
  {
    "value": "IS",
    "text": "ICELAND"
  },
  {
    "value": "IN",
    "text": "INDIA"
  },
  {
    "value": "ID",
    "text": "INDONESIA"
  },
  {
    "value": "IR",
    "text": "IRAN"
  },
  {
    "value": "IQ",
    "text": "IRAQ"
  },
  {
    "value": "IE",
    "text": "IRELAND"
  },
  {
    "value": "IL",
    "text": "ISRAEL"
  },
  {
    "value": "IT",
    "text": "ITALY"
  },
  {
    "value": "CI",
    "text": "IVORY COAST"
  },
  {
    "value": "JM",
    "text": "JAMAICA"
  },
  {
    "value": "JP",
    "text": "JAPAN"
  },
  {
    "value": "JO",
    "text": "JORDAN"
  },
  {
    "value": "KZ",
    "text": "KAZAKHSTAN"
  },
  {
    "value": "KE",
    "text": "KENYA"
  },
  {
    "value": "KI",
    "text": "KIRIBATI"
  },
  {
    "value": "KP",
    "text": "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF"
  },
  {
    "value": "KR",
    "text": "KOREA, REPUBLIC OF"
  },
  {
    "value": "KV",
    "text": "KOSOVO"
  },
  {
    "value": "KW",
    "text": "KUWAIT"
  },
  {
    "value": "KG",
    "text": "KYRGYZSTAN"
  },
  {
    "value": "LA",
    "text": "LAO PEOPLE'S DEM. REP."
  },
  {
    "value": "LV",
    "text": "LATVIA"
  },
  {
    "value": "LB",
    "text": "LEBANON"
  },
  {
    "value": "LS",
    "text": "LESOTHO"
  },
  {
    "value": "LR",
    "text": "LIBERIA"
  },
  {
    "value": "LY",
    "text": "LIBYA"
  },
  {
    "value": "LI",
    "text": "LIECHTENSTEIN"
  },
  {
    "value": "LT",
    "text": "LITHUANIA"
  },
  {
    "value": "LU",
    "text": "LUXEMBOURG"
  },
  {
    "value": "MO",
    "text": "MACAU"
  },
  {
    "value": "MK",
    "text": "MACEDONIA"
  },
  {
    "value": "MG",
    "text": "MADAGASCAR"
  },
  {
    "value": "MW",
    "text": "MALAWI"
  },
  {
    "value": "MY",
    "text": "MALAYSIA"
  },
  {
    "value": "MV",
    "text": "MALDIVES"
  },
  {
    "value": "ML",
    "text": "MALI"
  },
  {
    "value": "MT",
    "text": "MALTA"
  },
  {
    "value": "MH",
    "text": "MARSHALL ISLANDS"
  },
  {
    "value": "MR",
    "text": "MAURITANIA"
  },
  {
    "value": "MU",
    "text": "MAURITIUS"
  },
  {
    "value": "YT",
    "text": "MAYOTTE"
  },
  {
    "value": "MX",
    "text": "MEXICO"
  },
  {
    "value": "FM",
    "text": "MICRONESIA"
  },
  {
    "value": "MD",
    "text": "MOLDOVA"
  },
  {
    "value": "MC",
    "text": "MONACO"
  },
  {
    "value": "MN",
    "text": "MONGOLIA"
  },
  {
    "value": "ME",
    "text": "MONTENEGRO"
  },
  {
    "value": "MS",
    "text": "MONTSERRAT"
  },
  {
    "value": "MA",
    "text": "MOROCCO"
  },
  {
    "value": "MZ",
    "text": "MOZAMBIQUE"
  },
  {
    "value": "MM",
    "text": "MYANMAR"
  },
  {
    "value": "NA",
    "text": "NAMIBIA"
  },
  {
    "value": "NR",
    "text": "NAURU ISLAND"
  },
  {
    "value": "NP",
    "text": "NEPAL"
  },
  {
    "value": "NL",
    "text": "NETHERLANDS"
  },
  {
    "value": "AN",
    "text": "NETHERLANDS ANTILLES"
  },
  {
    "value": "NC",
    "text": "NEW CALEDONIA"
  },
  {
    "value": "NZ",
    "text": "NEW ZEALAND"
  },
  {
    "value": "NI",
    "text": "NICARAGUA"
  },
  {
    "value": "NE",
    "text": "NIGER"
  },
  {
    "value": "NG",
    "text": "NIGERIA"
  },
  {
    "value": "NU",
    "text": "NIUE"
  },
  {
    "value": "NF",
    "text": "NORFOLK ISLAND"
  },
  {
    "value": "MP",
    "text": "NORTHERN MARIANA IS."
  },
  {
    "value": "NO",
    "text": "NORWAY"
  },
  {
    "value": "OM",
    "text": "OMAN"
  },
  {
    "value": "PK",
    "text": "PAKISTAN"
  },
  {
    "value": "PW",
    "text": "PALAU"
  },
  {
    "value": "PS",
    "text": "PALESTINIAN TERR OCCUPIED"
  },
  {
    "value": "PA",
    "text": "PANAMA"
  },
  {
    "value": "PG",
    "text": "PAPUA NEW GUINEA"
  },
  {
    "value": "PY",
    "text": "PARAGUAY"
  },
  {
    "value": "PE",
    "text": "PERU"
  },
  {
    "value": "PH",
    "text": "PHILIPPINES"
  },
  {
    "value": "PN",
    "text": "PITCAIRN ISLAND"
  },
  {
    "value": "PL",
    "text": "POLAND"
  },
  {
    "value": "PT",
    "text": "PORTUGAL"
  },
  {
    "value": "PR",
    "text": "PUERTO RICO"
  },
  {
    "value": "QA",
    "text": "QATAR"
  },
  {
    "value": "RE",
    "text": "REUNION"
  },
  {
    "value": "RO",
    "text": "ROMANIA"
  },
  {
    "value": "RU",
    "text": "RUSSIA"
  },
  {
    "value": "RW",
    "text": "RWANDA"
  },
  {
    "value": "GS",
    "text": "S. GEORGIA & S. SANDWICH IS."
  },
  {
    "value": "WS",
    "text": "SAMOA"
  },
  {
    "value": "SM",
    "text": "SAN MARINO"
  },
  {
    "value": "ST",
    "text": "SAO TOME AND PRINCIPE"
  },
  {
    "value": "SA",
    "text": "SAUDI ARABIA"
  },
  {
    "value": "SN",
    "text": "SENEGAL"
  },
  {
    "value": "RS",
    "text": "SERBIA"
  },
  {
    "value": "SC",
    "text": "SEYCHELLES"
  },
  {
    "value": "SL",
    "text": "SIERRA LEONE"
  },
  {
    "value": "SG",
    "text": "SINGAPORE"
  },
  {
    "value": "SK",
    "text": "SLOVAKIA"
  },
  {
    "value": "SI",
    "text": "SLOVENIA"
  },
  {
    "value": "SB",
    "text": "SOLOMON ISLANDS"
  },
  {
    "value": "SO",
    "text": "SOMALIA"
  },
  {
    "value": "ZA",
    "text": "SOUTH AFRICA"
  },
  {
    "value": "ES",
    "text": "SPAIN"
  },
  {
    "value": "S4",
    "text": "SPANISH NORTH AFRICAN TER"
  },
  {
    "value": "LK",
    "text": "SRI LANKA"
  },
  {
    "value": "KN",
    "text": "ST. KITTS-NEVIS"
  },
  {
    "value": "SH",
    "text": "ST. HELENA"
  },
  {
    "value": "LC",
    "text": "ST. LUCIA"
  },
  {
    "value": "PM",
    "text": "ST. PIERRE AND MIQUELON"
  },
  {
    "value": "VC",
    "text": "ST. VINCENT & GRENADINES"
  },
  {
    "value": "SD",
    "text": "SUDAN"
  },
  {
    "value": "SR",
    "text": "SURINAME"
  },
  {
    "value": "SJ",
    "text": "SVALBARD & JAN MAYAN IS."
  },
  {
    "value": "SZ",
    "text": "SWAZILAND"
  },
  {
    "value": "SE",
    "text": "SWEDEN"
  },
  {
    "value": "CH",
    "text": "SWITZERLAND"
  },
  {
    "value": "SY",
    "text": "SYRIA"
  },
  {
    "value": "TW",
    "text": "TAIWAN"
  },
  {
    "value": "TJ",
    "text": "TAJIKISTAN"
  },
  {
    "value": "TZ",
    "text": "TANZANIA"
  },
  {
    "value": "TH",
    "text": "THAILAND"
  },
  {
    "value": "T6",
    "text": "TIBET"
  },
  {
    "value": "TL",
    "text": "TIMOR-LESTE"
  },
  {
    "value": "TG",
    "text": "TOGO"
  },
  {
    "value": "TK",
    "text": "TOKELAU"
  },
  {
    "value": "TO",
    "text": "TONGA"
  },
  {
    "value": "TT",
    "text": "TRINIDAD AND TOBAGO"
  },
  {
    "value": "TN",
    "text": "TUNISIA"
  },
  {
    "value": "TR",
    "text": "TURKEY"
  },
  {
    "value": "TM",
    "text": "TURKMENISTAN"
  },
  {
    "value": "TC",
    "text": "TURKS AND CAICOS IS."
  },
  {
    "value": "TV",
    "text": "TUVALU"
  },
  {
    "value": "UM",
    "text": "U.S. MINOR OUTLYING IS."
  },
  {
    "value": "UG",
    "text": "UGANDA"
  },
  {
    "value": "UA",
    "text": "UKRAINE"
  },
  {
    "value": "QZ",
    "text": "UN IN KOSOVO"
  },
  {
    "value": "AE",
    "text": "UNITED ARAB EMIRATES"
  },
  {
    "value": "UY",
    "text": "URUGUAY"
  },
  {
    "value": "UZ",
    "text": "UZBEKISTAN"
  },
  {
    "value": "VU",
    "text": "VANUATU"
  },
  {
    "value": "VA",
    "text": "VATICAN CITY STATE"
  },
  {
    "value": "VE",
    "text": "VENEZUELA"
  },
  {
    "value": "VN",
    "text": "VIETNAM"
  },
  {
    "value": "VI",
    "text": "VIRGIN IS."
  },
  {
    "value": "WF",
    "text": "WALLIS AND FUTUNA"
  },
  {
    "value": "EH",
    "text": "WESTERN SAHARA"
  },
  {
    "value": "YE",
    "text": "YEMEN"
  },
  {
    "value": "YU",
    "text": "YUGOSLAVIA"
  },
  {
    "value": "ZR",
    "text": "ZAIRE"
  },
  {
    "value": "ZM",
    "text": "ZAMBIA"
  },
  {
    "value": "ZW",
    "text": "ZIMBABWE"
  }
];

const PersonalFieldSet = (props) => {
  const { displayMiniAppFields, displayFullAppFields, isReadOnly, isUsCitizen } = props;
  const displayCountryOfCitizenship = isUsCitizen === "false";

  return (
    <fieldset className="container">
      <legend className="row">Personal</legend>
      { displayMiniAppFields &&
        <div className="row personal-mini-app-row">
          <div className="col-12 col-lg-6">
            <Field
              name="ssn"
              label="Social security number"
              component={SsnInput}
              type="text"
              validate={[required, validateSsnLength]}
              required={true}
              htmlAttributes={{
                minLength: "11",
                maxLength: "11",
                disabled: isReadOnly
              }}
              smallDisclosure={{
                text: "To confirm your credit report (necessary for all credit applications), and for account maintenance.  We only accept valid U.S. Social Security numbers."
              }}
            />
          </div>
          <div className="col-12 col-lg-6">
            <Field
              name="dateOfBirth"
              label="Date of birth"
              component={Input}
              type="text"
              normalize={toDate}
              format={formatDate}
              validate={[required, validateDateLength, validateDate]}
              required={true}
              htmlAttributes={{
                minLength: "10",
                maxLength: "10",
                disabled: isReadOnly
              }}
              smallDisclosure={{
                text: "To establish your eligibility for an account and, after you become a customer, to verify your identity."
              }}
            />
          </div>
        </div>
      }
      { displayFullAppFields && [
        <div className="row personal-full-app-row" key="PersonalFullAppFieldsRow1">
          <div className="col-12 col-lg-6">
            <Field
              name="mothersMaidenName"
              label="Mother's maiden name"
              component={Input}
              type="text"
              validate={[required, alphaName, notEmpty]}
              required={true}
              htmlAttributes={{
                maxLength: "15"
              }}
              smallDisclosure={{
                text: "To verify your identity when you call us. Last name only."
              }}
            />
          </div>
          <div className="col-12 col-lg-6">
            <Field
              name="totalAssets"
              label="Total assets (opt.)"
              component={Input}
              type="text"
              format={formatAmount}
              normalize={toNumber}
              htmlAttributes={{ maxLength: "12" }}
              smallDisclosure={{
                text: "Assets you'd like considered as a basis of repayment of the loan."
              }}
              postfix=".00"
            />
          </div>
        </div>,
        <div className="row personal-full-app-row" key="PersonalFullAppFieldsRow2">
          <div className="col-12 col-lg-6">
            <Field
              name="usCitizen"
              label="Are you a U.S. citizen"
              component={Select}
              type="text"
              validate={[required]}
              required={true}
              disabled={isReadOnly}
            >
              <YesOrNoOptionList />
            </Field>
          </div>
          { displayCountryOfCitizenship &&
          <div className="col-12 col-lg-6 personal-country-of-citizenship">
            <Field
              name="countryOfCitizenship"
              label="Country Of Citizenship"
              component={Select}
              type="text"
              validate={[required]}
              required={true}
              disabled={isReadOnly}
            >
              <OptionList options={countriesOfCitizenship} />
            </Field>
          </div>
          }
        </div>
      ]}
    </fieldset>);
};


PersonalFieldSet.defaultProps = {
  displayMiniAppFields: true,
  displayFullAppFields: true
};

PersonalFieldSet.propTypes = {
  isReadOnly: PropTypes.bool,
  isUsCitizen: PropTypes.string,
  displayMiniAppFields: PropTypes.bool,
  displayFullAppFields: PropTypes.bool
};

export default PersonalFieldSet;
